import { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "@/i18n";
import { sendContactMessage } from "@/lib/api";

export default function Contact() {
  const { t, locale } = useI18n();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    try {
      await sendContactMessage(form);
      toast.success(t.contact.success);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error(t.contact.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <div className="container">
        <section className="page-hero">
          <span className="eyebrow">{t.nav.contact}</span>
          <h1 className="mb-4">{t.contact.title}</h1>
          <p className="lede">{t.contact.subtitle}</p>
        </section>

        <div className="grid gap-6 lg:grid-cols-[0.8fr_1.2fr]">
          <aside className="panel p-7">
            <div className="space-y-6">
              <div className="flex items-start gap-3">
                <Mail size={18} style={{ color: "var(--color-terracotta)", marginTop: 3 }} />
                <div>
                  <p className="mb-1 text-xs font-bold uppercase tracking-[0.16em]" style={{ color: "var(--color-text-light)" }}>
                    Email
                  </p>
                  <a href="mailto:dalilaaint@gmail.com">dalilaaint@gmail.com</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} style={{ color: "var(--color-terracotta)", marginTop: 3 }} />
                <div>
                  <p className="mb-1 text-xs font-bold uppercase tracking-[0.16em]" style={{ color: "var(--color-text-light)" }}>
                    Studio
                  </p>
                  <p>{locale === "it" ? "Italia" : "Italy"}</p>
                </div>
              </div>
            </div>
          </aside>

          <form onSubmit={handleSubmit} className="panel form-grid p-7 md:p-8">
            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label className="form-label">{t.contact.name} *</label>
                <input
                  type="text"
                  required
                  value={form.name}
                  onChange={(event) => setForm({ ...form, name: event.target.value })}
                  className="input-shell"
                />
              </div>
              <div>
                <label className="form-label">{t.contact.email} *</label>
                <input
                  type="email"
                  required
                  value={form.email}
                  onChange={(event) => setForm({ ...form, email: event.target.value })}
                  className="input-shell"
                />
              </div>
            </div>
            <div>
              <label className="form-label">{t.contact.subject}</label>
              <input
                type="text"
                value={form.subject}
                onChange={(event) => setForm({ ...form, subject: event.target.value })}
                className="input-shell"
              />
            </div>
            <div>
              <label className="form-label">{t.contact.message} *</label>
              <textarea
                required
                rows={7}
                value={form.message}
                onChange={(event) => setForm({ ...form, message: event.target.value })}
                className="input-shell resize-none"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full sm:w-fit">
              {loading ? t.common.loading : t.contact.send}
              <Send size={16} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
